import {Eventify} from './Eventify.js';
import {Templates} from './Templates.js';

export class Registration extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = Templates(`Registration`);
		this.attachShadow({mode:"open"});
		this.shadowRoot.appendChild(this.el);
		Eventify(this.shadowRoot, this);
		if (this.isCompatibleBrowser()) {
			this.$.useChrome.remove();
		}
		let data = localStorage.getItem(`veedo-bbb-registration-data`);
		if (data) {
			data = JSON.parse(data);
			this.$.name.value = data.name;
			this.$.email.value = data.email;
			this.$.tel.value = data.tel;
			this.$.teacher_number.value = data.teacher_number;
			for (let i=0; i<this.$.province.options.length; i++) {
				if (this.$.province.options[i].value == data.province) {
					this.$.province.selectedIndex=i;
					break;
				}
			}
			this.$.district.value = data.district;
			this.$.gender.value = data.gender;
		}		
		this.$.uid.value = this.getUid();
	}
	register(evt) {
		evt.stopPropagation();
		evt.preventDefault();
		if (!this.$.form.reportValidity()) {
			return;
		}
		const name = this.$.name.value;
		const email = this.$.email.value;
		const tel = this.$.tel.value;
		const teacher_number = this.$.teacher_number.value;
		const province = this.$.province.options[this.$.province.selectedIndex].value;
		if (this.$.province.selectedIndex==0) {
			this.$.province.focus();
			alert(`Please select a province.`);
			return;
		}
		this.$.register.setAttribute(`disabled`,`disabled`);

		if (true) {
			// allow the form to submit
			this.$.form.submit();
			return true;
		} else {
			const data = JSON.stringify({
					"uid": this.getUid(),
					"name": this.$.name.value,
					"email": this.$.email.value,
					"tel": this.$.tel.value,
					"teacher_number": this.$.teacher_number.value,
					"province": this.$.province.options[this.$.province.selectedIndex].value,
					"district": this.$.district.value,
					"gender": this.$.gender.value,
				});
			localStorage.setItem(`veedo-bbb-registration-data`, data);
			fetch("json/register", {
				method: `POST`,
				body: data
			}).then(
				res=>res.json()
			).then(
				res=>{
					console.log(`json/register returned `, res);
					if (res.join) {
						document.location = res.join;
						return;
					}
				})
			.catch(err=>console.error(err))
			.finally( ()=>{
				this.$.register.removeAttribute(`disabled`);
			});
		}
	}
	// Browser detection from https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browsers
	isFirefox() {
		return typeof InstallTrigger !== 'undefined';
	}
	isCompatibleBrowser() {
		// Opera 8.0+
		const isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

		// Firefox 1.0+
		const isFirefox = typeof InstallTrigger !== 'undefined';

		// Safari 3.0+ "[object HTMLElementConstructor]" 
		const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

		// Internet Explorer 6-11
		const isIE = /*@cc_on!@*/false || !!document.documentMode;

		// Edge 20+
		const isEdge = !isIE && !!window.StyleMedia;

		// Chrome 1 - 79
		const isChrome = (navigator.userAgent.indexOf("Chrome") > -1) || (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime));

		// Edge (based on chromium) detection
		const isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

		// Blink engine detection
		const isBlink = (isChrome || isOpera) && !!window.CSS;

		return isChrome || isEdgeChromium || isSafari;	
	}
	// getUid returns a unique uid for this browser, so we can see when the same
	// person registers multiple times, perhaps with slightly changed details. So this
	// is useful for de-duplication.
	getUid() {
		const key = `veedo-bbb-registration-uid`;
		let guid = localStorage.getItem(key);
		if (guid) return guid;
		guid = crypto.randomUUID();
		localStorage.setItem(key, guid);
		return guid;
	}
}
customElements.define(`veedo-bbb-registration`, Registration);